const readmore = () => {
  const readMoreBtn = document.querySelectorAll('.read-more-button')

  if (!readMoreBtn || readMoreBtn.length === 0) {
    return
  }

  readMoreBtn.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault()
      // nextElementSibling is the next sibling element of the current element with the class read-more-content. If this element not exist, it will return null.
      const readMoreContent = e.target.nextElementSibling

      if (
        !readMoreContent ||
        !readMoreContent.classList.contains('read-more-content')
      ) {
        return
      }
      if (readMoreContent.getAttribute('aria-hidden') === 'false') {
        readMoreContent.setAttribute('aria-hidden', 'true')
        return
      }
      readMoreContent.setAttribute('aria-hidden', 'false')
    })
  })
}

export default readmore
